<template>
    <div class="relative bg-orange-100 pb-6 overflow-hidden">
        <!-- Hero Section -->
        <div
            class="bg-linear-to-r from-yellow-500 to-orange-500 flex flex-col items-center pt-12 pb-16 px-6 sm:px-12 lg:px-24 text-center">
            <h1 class="text-5xl font-serif font-bold text-white animate__animated animate__fadeInBottomRight">
                ¿Listo para aumentar tus ventas?
            </h1>
            <img src="@/assets/img/vsc.png" alt="publicidad"
                class="w-40 h-30 mx-auto mt-4 animate__animated animate__fadeInUp">
            <p class="mt-6 text-lg text-white max-w-3xl animate__animated animate__fadeInBottomLeft">
                Juntos reactivando la economia local, aumentando las ventas y empoderando al consumidor con
                <b>Virtual Shopping Club</b>.
                <br><b>¡El momento de
                    crecer es ahora!</b>
            </p>

            <router-link :to="registroRoute" class="mt-6 px-8 py-3 bg-red-500 text-white font-bold text-lg rounded-full
                                  hover:bg-green-500 hover:text-white transition-all">
                ¡Regístrate Ahora!
            </router-link>
        </div>

        <!-- Video Explicativo -->
        <div class="mt-14 bg-orange-100 text-center">
            <!-- Video de YouTube -->
            <div class="mx-auto max-w-4xl px-6 lg:px-8">
                <div class="aspect-w-16 aspect-h-9">
                    <iframe class="absolute rounded-lg  top-0 left-0 w-full h-full"
                        src="https://www.youtube.com/embed/M4o5Zc7c3fQ" frameborder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                </div>
            </div>
        </div>

        <!-- Patrocinio VSC -->
        <section class="relative bg-orange-100 py-24 px-6 overflow-hidden">
            <div
                class="absolute top-0 right-0 w-96 h-96 bg-orange-400 rounded-full opacity-30 -z-10 blur-3xl animate-pulse">
            </div>
            <div class="max-w-7xl mx-auto">
                <div class="text-center mb-16">
                    <h2 class="text-4xl md:text-5xl font-extrabold text-orange-700 leading-tight animate-bounce-in">
                        Iniciativa "Ciudades con Vida Digna"
                    </h2>
                    <p class="text-lg md:text-xl text-orange-700 max-w-3xl mx-auto mt-4 mb-10 animate-fade-in-slow">
                        <span class="font-semibold text-orange-800">Yatvii S de R.L.</span> empresa socialmente
                        responsable está invirtiendo entre
                        <span class="text-orange-800 font-bold">$465,500,000 y $1,225,000,000 MXN</span> para apoyar a
                        más de <span class="text-orange-900 font-bold">122,000 negocios</span> como el tuyo con la
                        campaña de cupones de descuentos para el fortalecimiento, tecnificacion del comercio local y
                        el empoderamiento del consumidor.
                    </p>
                </div>

                <!-- Nueva sección con diseño distinto -->
                <h1 class="text-orange-700 text-3xl text-center font-bold mb-2">A Nivel Nacional</h1>
                <div data-aos="fade-up" class="grid md:grid-cols-3 gap-10 text-white">
                    <div
                        class="bg-gradient-to-br from-orange-500 to-yellow-400 p-10 rounded-3xl shadow-lg transform hover:scale-105 transition duration-300 animate-fade-in">
                        <div class="flex items-center justify-center mb-4">
                            <span class="text-5xl">📍</span>
                        </div>
                        <h3 class="text-2xl font-bold mb-2 text-center">245 Zonas</h3>
                        <p class="text-center text-orange-50">Zonas en todo México</p>
                    </div>

                    <div
                        class="bg-gradient-to-br from-yellow-500 to-orange-500 p-10 rounded-3xl shadow-lg transform hover:scale-105 transition duration-300 animate-fade-in">
                        <div class="flex items-center justify-center mb-4">
                            <span class="text-5xl">💼</span>
                        </div>
                        <h3 class="text-2xl font-bold mb-2 text-center">+122,500</h3>
                        <p class="text-center text-orange-50">Negocios patrocinados</p>
                    </div>

                    <div
                        class="bg-gradient-to-br from-orange-400 to-yellow-300 p-10 rounded-3xl shadow-lg transform hover:scale-105 transition duration-300 animate-fade-in">
                        <div class="flex items-center justify-center mb-4">
                            <span class="text-5xl">💰</span>
                        </div>
                        <h3 class="text-2xl font-bold mb-2 text-center">$465M - $1.22B</h3>
                        <p class="text-center text-orange-50">Inversión total (MXN)</p>
                    </div>
                </div>

                <div data-aos="fade-up"
                    class="w-full max-w-3xl mx-auto bg-white rounded-xl flex justify-center items-center mt-16 mb-16">
                    <img src="@/assets/img/inversion.jpg" alt="VSC" class="w-full md:w-3/4 h-auto rounded-lg" />
                </div>

                <h1 class="text-orange-700 text-3xl text-center font-bold mb-2">A Nivel ciudad o zona</h1>
                <div data-aos="fade-up" class="grid md:grid-cols-2 gap-10 text-white">
                    <div
                        class="bg-gradient-to-br from-orange-500 to-yellow-400 p-10 rounded-3xl shadow-lg transform hover:scale-105 transition duration-300 animate-fade-in">
                        <div class="flex items-center justify-center mb-4">
                            <span class="text-5xl">💼</span>
                        </div>
                        <h3 class="text-2xl font-bold mb-2 text-center">500</h3>
                        <p class="text-center text-orange-50">Negocios patrocinados aproximadamente</p>
                    </div>
                    <div
                        class="bg-gradient-to-br from-orange-400 to-yellow-300 p-10 rounded-3xl shadow-lg transform hover:scale-105 transition duration-300 animate-fade-in">
                        <div class="flex items-center justify-center mb-4">
                            <span class="text-5xl">💰</span>
                        </div>
                        <h3 class="text-2xl font-bold mb-2 text-center">$1.9M a $5M</h3>
                        <p class="text-center text-orange-50">De inversión por ciudad</p>
                    </div>
                </div>

                <section class="mt-20 text-center animate-slide-up">
                    <div class="flex items-center justify-center">
                        <div class="max-w-4xl w-full rounded-2xl">
                            <h2 class="text-3xl text-orange-700 font-bold text-center mb-6">
                                ¡Aprovecha los Patrocinios que Yatvii tiene para ti!
                            </h2>
                            <p class="text-xl text-gray-700 text-center mb-8">
                                En el inicio de la campaña de cupones en tu zona que tiene un valor <span
                                    class="font-semibold">$10,000 MXN</span>. Yatvii ofrece patrocinios especiales.
                            </p>

                            <div class="grid md:grid-cols-2 gap-6">
                                <!-- 90% Patrocinio -->
                                <div data-aos="fade-up" class="rounded-xl p-6 text-center">
                                    <h3 class="text-xl font-bold text-green-700">90% Patrocinio</h3>
                                    <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                                            class="text-green-700">$1,000</span></p>
                                </div>

                                <!-- 50% Patrocinio -->
                                <div data-aos="fade-up" class="rounded-xl p-6 text-center">
                                    <h3 class="text-xl font-bold text-green-700">50% Patrocinio</h3>
                                    <p class="text-lg font-semibold text-gray-800">Aporte del negocio: <span
                                            class="text-green-700">$5,000</span></p>
                                </div>
                            </div>
                            <p class="text-2xl text-orange-700 font-medium mb-2 mt-4 animate-fade-in delay-500">
                                ¿Qué tienen que hacer los negocios?
                            </p>
                            <ul class="text-xl text-gray-700 mb-12 animate-fade-in delay-500">
                                <li>1. Cubrir aportación (Con o Sin patrocinio)</li>
                                <li>2. Desear tener $1,000,000 en ventas o en beneficios</li>
                                <li>3. Otorgar <strong>descuentos</strong> desde el 10% a miembros del club</li>
                            </ul>
                        </div>
                    </div>
                    <div data-aos="zoom-out-up">
                        <router-link :to="registroRoute"
                            class="boton bg-blue-600 gradient-bg text-white text-xl font-semibold py-4 px-8 rounded-full shadow-lg">
                            ✨ Quiero Mas Infomacion
                        </router-link>
                    </div>
                </section>
            </div>
        </section>

        <div class=" mx-auto text-center">
            <div class="p-6 rounded-lg shadow-lg text-center">
                <h3 class="text-xl font-bold text-red-500">❌ ¿Pocas ventas y clientes que solo compran una vez?</h3>
                <p class="text-gray-700 mt-2 text-center">
                    Si los clientes llegan, compran una vez y no vuelven, necesitas una estrategia diferente.
                </p>
            </div>
        </div>

        <!-- Sección de Beneficios -->
        <div class="bg-orange-100">
            <div class="max-w-4xl mx-auto px-6 lg:px-12 mb-14 text-center">
                <p
                    class="text-lg md:text-xl text-gray-700 leading-relaxed bg-white border-l-4 border-r-4 border-blue-600 p-4 rounded-xl shadow-sm">
                    Sé parte de nuestro <strong class="text-orange-600">Club de Negocios</strong> de <strong
                        class="text-blue-600">Virtual
                        Shopping Club</strong>,
                    una aplicación móvil que convierte los gastos comunes —tuyos o de
                    tus conocidos—
                    en una nueva forma de generar <span class="font-semibold text-orange-600">ingresos
                        constantes</span>.
                </p>
            </div>

            <h2 class="text-4xl font-serif font-bold text-center text-orange-800 mb-12">
                En Virtual Shopping Club obtienes acceso a <span class="text-yellow-500 font-bold">3 tecnologías
                    exclusivas</span> que impulsarán tu negocio:
            </h2>


            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto px-6 lg:px-12">
                <div
                    class="bg-white border border-orange-200 p-6 rounded-lg shadow-lg shadow-orange-500 text-center hover:shadow-xl transition">
                    <h3 class="text-2xl font-serif font-semibold text-orange-700">🎟️ Campaña de cupones</h3>
                    <p class="mt-2 text-gray-600">
                        Con nuestras campañas tendrás una forma muy efectiva de atraer nuevos clientes, dar a conocer tu
                        negocio y potencializar tus ventas.
                    </p>
                </div>

                <div
                    class="bg-white border border-orange-200 p-6 rounded-lg shadow-lg shadow-orange-500 text-center hover:shadow-xl transition">
                    <h3 class="text-2xl font-serif font-semibold text-orange-700">🏆 Centro de canje de puntos</h3>
                    <p class="mt-2 text-gray-600">
                        Al ser tu negocio un centro de canje de puntos vas a obtener clientes fieles, tecnificación de
                        tu negocio y ventaja competitiva con negocios externos.
                    </p>
                </div>

                <div
                    class="bg-white border border-orange-200 p-6 rounded-lg shadow-lg shadow-orange-500 text-center hover:shadow-xl transition">
                    <h3 class="text-2xl font-serif font-semibold text-orange-700">🤝 Patrocinador F3</h3>
                    <p class="mt-2 text-gray-600">
                        Una tecnología solo para <span class="font-semibold text-orange-700">miembros fundadores</span>
                        con la cual podras recibir ingresos pasivos por las ventas y cupones aplicados en la zona de tu
                        ciudad de residencia.
                    </p>
                </div>
            </div>
        </div>


        <!--Que tengo que hacer-->
        <div class="py-16 bg-orange-100">
            <h2 class="text-4xl font-serif font-bold text-center text-orange-800 mb-6">
                ¿Qué tengo que hacer?
            </h2>
            <div class="grid gap-8 max-w-7xl mx-auto px-6 lg:px-12">
                <div
                    class="bg-white border border-orange-200 p-8 rounded-2xl shadow-lg text-center hover:shadow-xl transition duration-300">
                    <h3 class="text-2xl font-serif font-semibold text-orange-700 mb-4">
                        ¡Empieza en 3 pasos!
                    </h3>
                    <p class="text-gray-700 mb-4">
                        <strong>1.</strong> Regístrate totalmente <span
                            class="text-orange-600 font-bold">gratis</span>.<br>
                        <strong>2.</strong> Descarga la app desde tu tienda de aplicaciones favorita.<br>
                        <strong>3.</strong> Contacta a tu asesor para recibir información y comenzar a generar ingresos.
                    </p>
                    <p class="text-gray-500 italic">
                        ¡Es rápido, sencillo y sin costo!
                    </p>
                </div>
            </div>
        </div>



        <!-- Programa de Ingresos Extras -->
        <div class="py-16 bg-linear-to-r from-orange-500 to-yellow-500 text-white text-center">
            <h2 class="text-4xl font-serif font-bold">💸 Tus ventas no tienen que ser tu única <span
                    class="text-yellow-900">fuente de ingresos.</span></h2>
            <p class="mt-6 max-w-4xl mx-auto text-lg px-2">
                Con el <b>Programa Fusión</b>, tu negocio desbloquea una nueva fuente de ingresos diseñada para
                brindarte <b>publicidad permanente</b>, <b>tecnificación de tu negocio</b> y un <b>flujo de ganancias
                    que
                    puede ir desde pequeños ingresos hasta cifras ilimitadas</b>.
                <br><br>
                Todo comienza al conectar personas y negocios a Virtual Shopping Club. Cuanto más compartes esta
                oportunidad, más crecen tus beneficios y el alcance de tu negocio.
            </p>

            <img src="@/assets/img/ingresosExt.png" alt="Ingresos" class="w-40 mx-auto my-6">
            <router-link :to="registroRoute"
                class="px-8 py-4 bg-white text-orange-800 font-bold text-lg rounded-full hover:bg-green-500 hover:text-white transition">
                ¡Descubre cómo funciona!🔥
            </router-link>
        </div>


        <!--Membresia y Programa f3 -->
        <div class=" max-w-4xl mx-auto text-center bg-orange-500 rounded-lg p-6 mt-2 bg-cover bg-center"
            :style="{ backgroundImage: `url(${require('@/assets/img/fondoNaranja.jpg')})` }">
            <div class="max-w-7xl mx-auto px-6 lg:px-8">
                <img src="@/assets/img/cardVSC.png" alt="Icono de publicidad" class="w-75 h-54 mx-auto mb-5">
                <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
                    Únete al club y aumenta tus ventas
                </h2>
                <p class="neon-black text-white text-lg leading-relaxed mb-12">
                    Como miembro del Club de Negocios, convierte tu marca en la favorita de nuestros clientes, con la
                    membresia anual
                    tu negocio tendrá mayores beneficios en publicidad, ventas efectivas,
                    ingresos extras y acceso a <span class="font-semibold">2 tecnologias</span> como la
                    campaña de cupones y ser centro de canje de puntos, las cuales te ayudarán a incrementar tus
                    ganacias desde pesitos a más
                    de $1,000,000 en ventas.
                    Aparte, contarás con
                    el apoyo de un experto en ventas y marketing. <br><br>
                </p>
                <h2 class="neon-black text-3xl font-serif font-extrabold text-center text-white mb-5 ">
                    Convierte en <span class="text-orange-500">miembro Fundador</span> del club de negocios
                </h2>
                <p class="neon-black text-white text-lg leading-relaxed mb-12">
                    <span class="font-bold">🎁 Sé de los primeros 100 negociós de la zona en unirse</span><br>
                    Obtén de cortesía la tecnologia F3 con la cual podrás recibir ingresos <span
                        class="font-semibold text-green-500">pasivos</span> de todas las <span
                        class="font-semibold text-green-500">ventas y cupones</span> aplicados en negocios
                    afiliados de una zona de México. No tienes que vender nada, solo aprovechar el
                    movimiento de la red de negocios. ¡Así de fácil! 💰🚀
                </p>

                <div class="neon-black mb-10 pt-2 pb-2 text-5xl font-bold ">
                    ⏳ <span class="neon-text text-red-700 text-5xl">{{ countdown }}</span>
                </div>
                <router-link :to="registroRoute" class="inline-block px-8 py-3 bg-white text-orange-700 font-bold text-lg rounded-lg
                                      shadow-lg hover:bg-green-600 hover:text-white transform hover:scale-105
                                      transition-all duration-300 mb-6">
                    ¡Aprovecha esta oferta exclusiva!
                </router-link>
            </div>
        </div>

        <!--por que unirse-->
        <section class="py-12 mt-8">
            <div class="max-w-4xl mx-auto text-center">
                <h2 class="text-3xl font-bold text-orange-800 mb-6">💡 ¿Por qué unirte?</h2>

                <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
                    <!-- Carga Administrativa Pesada -->
                    <div
                        class="bg-linear-to-b from-yellow-500 to-orange-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
                        <h3 class="text-xl font-bold text-white">✅ Ventas recurrentes</h3>
                        <p class="text-white mt-2 text-justify">Con el programa de cupones los clientes obtienen
                            descuentos de tus productos y puntos por comprar contigo, eso los motiva a regresar a tu
                            negocio, aparte tienes la posibilidad de recuperar los descuentos que apliques.</p>
                    </div>

                    <!-- Falta de Personalización -->
                    <div
                        class="bg-linear-to-b from-yellow-500 to-orange-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
                        <h3 class="text-xl font-bold text-white">✅ Más publicidad, sin complicaciones</h3>
                        <p class="text-white mt-2 text-justify">Te ayudamos a que más personas, dentro y fuera de la
                            comunidad de Virtual Shopping Club, conozcan tu marca y aumentes su presencia en el mercado,
                            a través de tres tecnologías exclusivas para negocios..</p>
                    </div>

                    <div
                        class="bg-linear-to-b from-yellow-500 to-orange-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
                        <h3 class="text-xl font-bold text-white">✅ Clientes fieles</h3>
                        <p class="text-white mt-2 text-justify">Olvídate de los clientes que solo compran una vez. En
                            nuestro club conectarás con
                            clientes que regresan y recomiendan.</p>
                    </div>

                    <div
                        class="bg-linear-to-b from-yellow-500 to-orange-500 p-6 rounded-lg shadow-lg text-center border border-blue-400 hover:border-blue-700">
                        <h3 class="text-xl font-bold text-white">✅ Gana dinero por recomendarnos.</h3>
                        <p class="text-white mt-2 text-justify">
                            Genera ingresos recomendando <b>Virtual Shopping Club</b> a tus amigos, clientes y
                            conocidos.
                            Cuantas más personas invites a unirse, <b>mayores serán tus ganancias</b>. ¡Convierte tus
                            conexiones en oportunidades reales de crecimiento!
                        </p>

                    </div>
                </div>
            </div>
        </section>

        <!-- Sección de Preguntas Frecuentes -->
        <div class="py-16 px-6 text-center text-gray-800">
            <h3 class="text-3xl font-bold text-orange-700"> Preguntas Frecuentes❓</h3>
            <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
                <summary class="font-semibold text-lg cursor-pointer"> ¿Qué necesito para unirme al club?</summary>
                <p class="mt-2">Solo necesitas tener un negocio físico, una actitud amable y de servicio, autorizar tu
                    marca o negocio para medios publicitarios ¡y listo!
                    obtén tu participacion en la campaña de negocios o tu membresia de negocios y disfrutar de los
                    beneficios.</p>
            </details>
            <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
                <summary class="font-semibold text-lg cursor-pointer"> ¿Qué negocios pueden participar?</summary>
                <p class="mt-2">¡Cualquiera! No importa si vendes un producto o prestas un servicio, puedes unirte al
                    club.
                    Lo único que necesitas es que tu negocio sea legal, pueda emitir facturas y des un minimo de 10% de
                    descuento a los miembros del club y cubrir la aportacion inicial.</p>
            </details>
            <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
                <summary class="font-semibold text-lg cursor-pointer"> ¿Dónde se mostrará la publicidad de mi negocio?
                </summary>
                <p class="mt-2 text-gray-700">
                    Tu negocio se beneficiará de campañas en redes sociales, publicidad orgánica a través de las cuentas
                    de nuestros socios, y materiales promocionales diseñados para destacar tu marca. Además, tendrás
                    presencia dentro de la aplicación <b>Virtual Shopping Club</b>, aumentando tu visibilidad ante
                    nuevos clientes de forma constante.
                </p>
            </details>

            <details class="mt-6 bg-white p-4 rounded-lg shadow-md">
                <summary class="font-semibold text-lg cursor-pointer"> No sé mucho de marketing, ¿es necesario para
                    unirme al club?</summary>
                <p class="mt-2"> ¡Para nada! No importa si eres experto en marketing o no. Aquí trabajarás con un
                    experto que te ayudará con las ventas, publicidad y hacer crecer tus contactos.</p>
            </details>
        </div>

        <!-- Llamada a la acción -->
        <div class="bg-linear-to-r from-orange-500 to-yellow-500 py-16 relative z-20 mt-14">
            <div class="max-w-7xl mx-auto text-center px-4 sm:px-6 lg:px-8">
                <h2 class="text-4xl text-white font-serif font-extrabold text-white animate-pulse">
                    💸 ¡Ventas aseguradas para tu negocio! 💸
                </h2>
                <img src="@/assets/img/vsc.png" alt="publicidad" class="w-40 h-30 mx-auto mt-4 mb-4">
                <router-link :to="registroRoute" class="inline-block px-8 py-4 bg-white text-orange-800 font-bold text-lg rounded-full
                                      shadow-lg hover:bg-green-600 hover:text-white transform hover:scale-105
                                      transition-all duration-300">
                    ¡Quiero mas ventas!
                </router-link>
            </div>
        </div>

        <patrocinadores-comp :patrocinadores="patrocinadores" v-if="patrocinadores.length > 0"></patrocinadores-comp>
    </div>
</template>

<script>
import patrocinadoresComp from "@/components/campanias/patrocinadores";

export default {
    name: 'ClubNegocios4',
    data() {
        return {
            countdown: "00:00:00",
        }
    },
    components: {
        patrocinadoresComp
    },
    props: {
        patrocinadores: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        fbq('init', '1351295932570313')
        fbq('track', 'PageView')
    },
    computed: {
        registroRoute() {
            return typeof this.$route.params.codigo !== 'undefined' ? `/registro/campania/${this.$route.params.codigo}` :
                '/registro'
        }
    },
    mounted() {
        this.startCountdown();
    },
    methods: {
        startCountdown() {
            this.updateCountdown(); // Llamar una vez al inicio para evitar el retraso del setInterval
            setInterval(this.updateCountdown, 1000);
        },
        updateCountdown() {
            const now = new Date();
            const midnight = new Date();

            // Configurar la fecha para la siguiente medianoche
            midnight.setHours(24, 0, 0, 0);

            const timeLeft = midnight - now; // Diferencia en milisegundos

            const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
            const seconds = Math.floor((timeLeft / 1000) % 60);

            this.countdown = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        }
    }
}
</script>

<style scoped>
/* Estilos personalizados */
.neon-text {
    text-shadow: 0 0 90px #ffffff, 0 0 20px #ffffff, 0 0 30px #ffffff;
}

.neon-black {
    text-shadow: 0 0 10px #000000, 0 0 10px #000000, 0 0 20px #000000;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

h1,
h2,
h3 {
    animation: fadeIn 1s ease-in-out;
}

.animated-gradient {
    animation: pulse 2s infinite;
    font-size: 2rem;
    /* Ajusta el tamaño */
    font-weight: 800;
    /* Fuente extrabold */
    text-align: center;
    /* Centrar texto */
    background: linear-gradient(90deg, #ffa52f, #ff9100, #ffa52f);
    /* Gradiente de 3 colores */
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    /* El gradiente aparecerá en lugar del color sólido */
    animation: gradient-animation 3s infinite;
    /* Añade la animación */
}

@keyframes gradient-animation {

    0%,
    100% {
        background-position: 0% 50%;
        transform: scale(0.8);
    }

    50% {
        background-position: 100% 50%;
        transform: scale(0.9);
    }
}

/* seccion de patrocinio vsc */
@keyframes bounce-in {
    0% {
        opacity: 0;
        transform: scale(0.9);
    }

    60% {
        opacity: 1;
        transform: scale(1.05);
    }

    100% {
        transform: scale(1);
    }
}

.animate-bounce-in {
    animation: bounce-in 1s ease-out;
}

@keyframes fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.animate-fade-in {
    animation: fade-in 1s ease-in forwards;
}

.animate-fade-in.delay-300 {
    animation-delay: 0.3s;
}

.animate-fade-in.delay-500 {
    animation-delay: 0.5s;
}

@keyframes fade-in-slow {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-fade-in-slow {
    animation: fade-in-slow 1.2s ease-in-out;
}

@keyframes slide-up {
    from {
        transform: translateY(30px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.animate-slide-up {
    animation: slide-up 1s ease-out forwards;
}

.gradient-bg {
    background: linear-gradient(45deg, #ffbe45, #ff9100, #ffbe45, #ff9100);
    background-size: 400% 400%;
    animation: gradientChange 4s ease infinite;
}
</style>